import {useEffect, useId, useRef, useState} from 'react';
import {Settings2, X} from 'lucide-react';
import {SettingsLayoutContext} from '@/components/SettingsSection';
import {DialogContainerContext} from '@/components/ui/dialog';
import {tr} from '@/i18n/copy';

// Keep forms mounted after their first opening so uploads and drafts survive closing.
export default function ArtistSettingsTile({open,onOpenChange,title,subtitle,children,id,status,footer}) {
  const dialog=useRef(null), trigger=useRef(null), label=useId();
  const [visited,setVisited]=useState(open), [container,setContainer]=useState(null);
  useEffect(()=>{
    if(open){setVisited(true);if(!dialog.current.open)dialog.current.showModal();}
    else if(dialog.current.open)dialog.current.close();
    if(!open)return;
    const overflow=document.body.style.overflow;document.body.style.overflow='hidden';
    return()=>{document.body.style.overflow=overflow;};
  },[open]);
  const close=()=>{dialog.current?.close();onOpenChange(false);trigger.current?.focus({preventScroll:true});};
  return <>
    <button id={id} ref={trigger} type="button" className="tps-entity-tile w-full" aria-haspopup="dialog" onClick={()=>onOpenChange(true)}>
      <Settings2 className="h-6 w-6 text-primary" aria-hidden="true"/>
      <b className="tps-entity-name">{title}</b><span className="text-xs text-muted-foreground">{subtitle}</span>{status}
      <span className="tps-entity-action">{tr('Apri impostazioni')}</span>
    </button>
    <dialog ref={dialog} aria-labelledby={label} className="tps-form-panel tps-form-panel-large" onCancel={e=>{if(e.target===dialog.current){e.preventDefault();close();}}} onClick={e=>{if(e.target===e.currentTarget)close();}}>
      <div className="tps-form-panel-header"><div><h2 id={label} className="text-lg font-semibold">{title}</h2><p className="mt-1 text-sm text-muted-foreground">{subtitle}</p></div><button type="button" onClick={close} aria-label={tr('Close')} className="rounded p-2"><X className="h-4 w-4"/></button></div>
      <div ref={setContainer} className="min-h-0 overflow-y-auto">
        <DialogContainerContext.Provider value={container}><SettingsLayoutContext.Provider value={null}>
          {visited&&<div className="tps-settings-body">{children}</div>}
        </SettingsLayoutContext.Provider></DialogContainerContext.Provider>
      </div>
      <div className="tps-settings-footer">{footer}<button type="button" className="rounded-lg border px-3 py-2 text-sm" onClick={close}>{tr('Torna alla pagina')}</button></div>
    </dialog>
  </>;
}
